import api from 'services/technical-visit/technical-visit'

export const handleRemoveMaintenanceAction = async (id: string, equipmentId: string, actionId: string) => {
  let res = await api.removeMaintenanceAction(id, equipmentId, actionId)

  return res?.data?.success
}
